import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors } from '@/utils/constants';

const darkTheme = {
  root: {
    '& $accordion': {
      color: TextColors.light,

      '& .MuiAccordionSummary-expandIcon': {
        color: SecondaryColors.main,
      },
    },
  },
};

const lightTheme = {
  root: {
    '& $accordion': {
      color: TextColors.dark,

      '& .MuiAccordionSummary-expandIcon': {
        color: SecondaryColors.dark,
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
    },
    accordion: {
      '&.MuiAccordion-root': {
        background: 'transparent',
        border: 'none',
        boxShadow: 'none',
      },
      '&:not(:last-child)': {
        borderBottom: 0,
      },
      '&:before': {
        display: 'none',
      },
      '&.Mui-expanded': {
        margin: 'auto',
      },
      '& .MuiAccordionSummary-expandIcon': {
        padding: 0,
      },
    },
    summary: {
      '&.MuiAccordionSummary-root': {
        minHeight: 0,
        paddingLeft: 0,
        paddingRight: muiTheme.spacing(1),

        '&.Mui-expanded': {
          minHeight: 0,
        },

        '& .MuiAccordionSummary-content': {
          margin: 0,
        },
      },
    },
    summaryDetails: {
      '&.MuiAccordionDetails-root': {
        padding: muiTheme.spacing(1, 0, 2),
      },

      '& .MuiFormControlLabel-root': {
        marginLeft: 0,
        marginRight: 0,
      },
    },
  }),
  { name: 'GenElasticAccordionFilter' },
);

export default useStyles;
